export default "__VITE_ASSET__BgFVnCrd__"